/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_Q3Inputs */

const en_guide_json_schema_faq_q3 = /** @type {(inputs: Guide_Json_Schema_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is JSON Schema an official standard?`)
};

const ko_guide_json_schema_faq_q3 = /** @type {(inputs: Guide_Json_Schema_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 공식 표준인가요?`)
};

const ja_guide_json_schema_faq_q3 = /** @type {(inputs: Guide_Json_Schema_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema は公式の標準ですか?`)
};

/**
* | output |
* | --- |
* | "Is JSON Schema an official standard?" |
*
* @param {Guide_Json_Schema_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_q3 = /** @type {((inputs?: Guide_Json_Schema_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_q3(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_q3(inputs)
	return ja_guide_json_schema_faq_q3(inputs)
});